import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider.jsx";
import { Spinner } from "../ui/primitives.jsx";

/* Guards /admin/* routes. Unauthenticated or non-allowlisted users are sent to
   sign-in. Security is ultimately enforced by Firestore rules; this is UX only. */
export default function RequireAuth({ children }) {
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ minHeight: "60vh", display: "grid", placeItems: "center", color: "var(--primary)" }}>
        <Spinner size={28} />
      </div>
    );
  }

  if (!user || !profile) {
    return <Navigate to="/admin/sign-in" replace state={{ from: location.pathname }} />;
  }

  return children;
}
